export default {
  show ({ commit }) {
    commit('setIsLoading', true)
  },

  hide ({ commit }) {
    commit('setIsLoading', false)
  }
}
